<template>
  <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">
        <div class="col-sm-auto col-4">
          <div class="avatar avatar-xl">
            <img :src="state.isLoading ? state.loadingImageUrl : state.associationLogoImageSrc" :alt="$t('association.Logo_image')" class="shadow-sm" />
          </div>
        </div>
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ state.name }}</h5>            
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>
    <div id="association-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Association_info') }}</h5>
      </div>      
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Name') }}:</label>
              <div class="display-field">{{ state.name }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Abbreviation') }}</label>
              <div class="display-field">{{ state.abbreviation }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Chamber_of_commerce_no') }}</label>
                <div class="display-field">{{ state.chamberOfCommerceNo }}</div>                
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('association.Phone_number') }} / {{ $t('association.Mobile_number') }}</label>
                  <div class="display-field">{{ state.phoneNumber }}</div>                  
              </div>
            </div>
        </div>        
      </div>
    </div>
    <div id="address" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Address') }}</h5>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static">
              <label class="">{{ $t('association.Address') }}</label>
              <div class="display-field">{{ state.address }}</div>              
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static">
              <label class="">{{ $t('association.House_number') }}</label>
              <div class="display-field">{{ state.houseNumber }}</div>              
            </div>
          </div>
        </div>      
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static">
              <label class="">{{ $t('association.City') }}</label>
              <div class="display-field">{{ state.city }}</div>              
            </div>
          </div>      
          <div class="col-4">
            <div class="input-group input-group-static">
              <label class="">{{ $t('association.Zipcode') }}</label>
              <div class="display-field">{{ state.zipcode }}</div>              
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static">
              <label class="">{{ $t('association.Country') }}</label>
              <div class="display-field">{{ state.country }}</div>              
            </div>
          </div>
        </div>        
      </div>
    </div>  
    <div class="row mt-4">      
      <div class="col-md-6">
        <div id="logoimage" class="card mt-4" data-animation="FadeIn">      
          <div class="row align-items-center justify-content-between">
            <div class="col">
              <div class="card-header pb-3">
                <h5>{{ $t('association.Logo_image') }}</h5>                
              </div>
            </div>            
          </div>
          <div class="card-body pt-0">
            <div class="row mt-2">
              <div class="col-12">
                <div class="avatar avatar-xl">
                  <img
                    :src="state.isLoading ? state.loadingImageUrl : state.associationLogoImageSrc"
                    :alt="$t('association.Logo_image')"
                    class="shadow-sm"
                  />
              </div>
              </div>   
            </div>            
          </div>
        </div>
      </div>
      <div class="col-md-6">        
      </div>
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Delete_association') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteAssociation" name="Delete Association" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.name }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteAssociation" @click="deleteAssociation" name="button">{{ $t('association.Delete_association') }}</button>
      </div>
    </div>
</template>

<script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { reactive } from 'vue'  
  import loadingImageUrl from "@/assets/img/LoadingImage.gif";

  export default {
    name: "AssociationOverview",
    setup() {
      const state = reactive ({
          association: [],          
          gets: [],
          id: '',
          name: '',
          abbreviation: '',
          chamberOfCommerceNo: '',
          phoneNumber: '',
          mobileNumber: '',
          address: '',
          houseNumber: '',
          city: '',
          zipcode: '',
          country: '',          
          deleteAssociation: false,
          isLoading: true,
          loadingImageUrl,
          associationLogoImageSrc: null,  
      })
      return {
          state
      }
    },    
    components: {     
      MaterialSwitch, 
    },
    data() {
      return {
        association: [],
        gets: [],
        id: '',
        name: '',
        abbreviation: '',
        chamberOfCommerceNo: '',
        phoneNumber: '',
        mobileNumber: '',
        address: '',
        houseNumber: '',
        city: '',
        zipcode: '',
        country: '',
        loadingImageUrl,
        associationLogoImageSrc: null,  
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;    
      await this.fetchAssociationData(this.$route.params.id);
      await this.fetchAssociationImage()
    },
    methods: {
      async fetchAssociationImage() {

        try {
          this.state.isLoading = true;

          try {
            const responseLogo = await axios.get(`association/getassociationlogo/`, {
              params: { associationId: this.state.id },
              responseType: 'blob',
            });

            const contentTypeLogo = responseLogo.headers['content-type'];

            if (!contentTypeLogo.startsWith('image/')) {
              this.state.associationLogoImageSrc = require('@/assets/no-image.png');
              return;
            }

            const imageLogoBlob = responseLogo.data;
            this.state.associationLogoImageSrc = URL.createObjectURL(imageLogoBlob);

          } catch (error) {
            this.state.associationLogoImageSrc = require('@/assets/no-image.png');
            console.error('Failed to fetch logo image:', error);
          }
        } finally {
            this.state.isLoading = false; // Set loading state to false after fetching
        }
      },
      async fetchAssociationData(associationId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Association/${associationId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.association = this.gets.data;

                this.state.id = this.state.association.id;
                this.state.ubn = this.state.association.ubn;
                this.state.name = this.state.association.name || '\u00A0';
                this.state.abbreviation = this.state.association.abbreviation;
                this.state.chamberOfCommerceNo = this.state.association.chamberOfCommerceNo || '\u00A0';
                this.state.phoneNumber = this.state.association.phoneNumber || '\u00A0';
                this.state.mobileNumber = this.state.association.mobileNumber || '\u00A0';
                this.state.address = this.state.association.address || '\u00A0';
                this.state.houseNumber = this.state.association.houseNumber || '\u00A0';
                this.state.city = this.state.association.city || '\u00A0';
                this.state.zipcode = this.state.association.zipcode || '\u00A0';
                this.state.country = this.state.association.country || '\u00A0';    
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      confirmDelete() {
        this.state.deleteAssociation = !this.state.deleteAssociation;
      },      
      deleteAssociation() {
        if (this.state.deleteAssociation) {
          this.deleteAssociation1(this.state.id)
        }
      },                  
      async deleteAssociation1(id) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("association/" + id);
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_association_deleted_successfully');              
              this.$router.push('/association');
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }         
      }
    }
  };
</script>
<style scoped>

.display-field {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #4ca750;
  padding: 2px 0;
  margin-top: 2px;
  background-color: transparent;  
  font-size: 0.875rem;
}

  .card-shadow-all {
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
  }

  .card-body .input-group-static {
    margin-bottom: 5px;
  }

  .card-body .form-control {
    padding: 8px;    
    border-radius: 4px;
  }

  .card-body label {  
    font-size: 0.875rem;
    font-weight: 400;
    color: #7b809a;
  }

  .font-size-18 {
    font-size: 18px !important;
  }
</style>